import React from 'react'
import * as css from '../deferred-payment-message.scss'

const KlarnaLogo = () => (
  <svg
    className={css.paymentMethodLogo}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="13px"
    viewBox="0 0 42 13"
  >
    <path
      fill="#000"
      d="M8.97 10.1h2.02V.59H8.97v9.5zM21.8 4.6v-.84H19.9v6.35h1.9V6.78c0-.96 1.08-1.38 1.84-1.18h.02V3.76a2.22 2.22 0 00-1.86.85zm-6.52 4.03c-1 0-1.79-.76-1.79-1.71s.81-1.7 1.8-1.7 1.78.75 1.78 1.7-.8 1.7-1.79 1.7zm1.78-4.45a3.34 3.34 0 10-1.94 6.08c.72 0 1.38-.23 1.94-.6v.44h1.65V3.74h-1.65v.44zm11.36-.6c-.76 0-1.48.23-1.96.87v-.7H24.56v6.35h1.9V6.62c0-.97.65-1.44 1.44-1.44.83 0 1.32.5 1.32 1.42v3.48h1.9V6.04c0-1.45-1.18-2.46-2.7-2.46zm12.33 4.27c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2 0-.68-.54-1.2-1.2-1.2zm-5.45.78c-1 0-1.8-.76-1.8-1.71s.82-1.7 1.8-1.7c1 0 1.79.75 1.79 1.7.02.95-.8 1.7-1.8 1.7zm1.79-4.45a3.34 3.34 0 10-1.94 6.08c.72 0 1.38-.23 1.94-.6v.44h1.65V3.74H37.1v.44zm2.85-.32h.09c.05 0 .08.04.08.07 0 .05-.02.07-.08.07h-.09v-.14zm0 .22h.09l.08.19h.09l-.09-.19c.05-.02.09-.07.09-.13 0-.09-.07-.16-.17-.16h-.17v.48h.08v-.19zM.04 10.1h2.12V.59H.05v9.5zM7.59.59H5.54A5.63 5.63 0 012.46 5.5l3.16 4.6H8.2L5.32 5.92A7.63 7.63 0 007.58.6zm32.43 3.07c.2 0 .37.17.37.37 0 .2-.17.37-.37.37a.37.37 0 01-.37-.37c0-.2.17-.37.37-.37zm0 .83c.25 0 .46-.2.46-.46 0-.25-.2-.45-.46-.45-.25 0-.46.2-.46.45s.2.46.46.46z"
    />
  </svg>
)

export default KlarnaLogo
